import React, { FC, useEffect } from 'react'
import { push } from 'connected-react-router'
import { isFulfilled } from '@reduxjs/toolkit'
import { FormikHelpers } from 'formik'

import Form from '../../components/Form'
import TextInput from '../../components/UI/Inputs/TextInput'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import { TUpdatePasswordFormValues } from '../../models/form'

import { useDispatch, useSelector } from '../../store'
import { checkTokenToUpdatePasswordThunk, updatePasswordThunk } from '../../store/auth/thunks'
import { NON_AUTH_ROUTE } from '../App/routes'

interface CalendarProps {}

const Calendar: FC<CalendarProps> = (props) => {
  const dispatch = useDispatch()
  const { location, inProgress } = useSelector((state) => ({
    location: state.router.location,
    inProgress: state.auth.inProgress
  }))

  const setUpForm = {
    initialValues: { password: '', password_confirmation: '' },
    validation: 'user',
    onSubmit: async (
      values: TUpdatePasswordFormValues,
      actions: FormikHelpers<TUpdatePasswordFormValues>
    ) => {
      const resetPassValues: any = {
        // TODO simplify
        token: (location as any).query.token,
        email: (location as any).query.email,
        password_confirmation: values.password_confirmation,
        password: values.password
      }
      const statusUpdatePassword = await dispatch(updatePasswordThunk(resetPassValues))
      if (isFulfilled(statusUpdatePassword as any)) dispatch(push(NON_AUTH_ROUTE.LOGIN))
    }
  }

  useEffect(() => {
    const checkToken = async () => {
      const checkValidTokenData = {
        // TODO simplify
        token: (location as any).query.token,
        email: (location as any).query.email
      }
      const statusToken = await dispatch(checkTokenToUpdatePasswordThunk(checkValidTokenData))
      if (!isFulfilled(statusToken as any)) dispatch(push(NON_AUTH_ROUTE.LOGIN))
    }

    checkToken()
  }, [location, dispatch])

  return (
    <div className='agency-creation-step'>
      <div className='agency-creation-step__title'>Reset password</div>
      <div className='agency-creation-step__description'>Create a new password</div>
      <Form {...setUpForm}>
        <TextInput
          name='password'
          label='Password'
          type='password'
          placeholder='Enter new password'
        />
        <TextInput
          name='password_confirmation'
          label='Confirm password'
          type='password'
          placeholder='Confirm your password'
        />
        <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
          Submit
        </CustomButton>
      </Form>
    </div>
  )
}

export default Calendar
